import { render } from "./Information.vue?vue&type=template&id=6a8a890e&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=6a8a890e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a8a890e"

export default script